export default __webpack_public_path__ + "static/cheer-bananas-square-20f1732df931a4b2a8c9464cb090585d.png";